import type { Root } from 'hast';
import rehypeStringify from 'rehype-stringify';
import { unified } from 'unified';

import type { Block, Document, Fragment, Inline } from '@gitbook/slate';
import { Trace } from '@gitbook/util-debug';

import { createFormattingContext, type FormattingContext } from '../context';
import { defaultFormattingOptions, type FormattingOptions } from '../options';
import { gastToHast } from './gastToHast';

/**
 * Format a document to a HTML string.
 */
export async function formatHTML(
    document: Document | Fragment | Inline | Block,
    options: FormattingOptions | FormattingContext = defaultFormattingOptions
): Promise<string> {
    const trace = new Trace('format.formatHTML', { silent: true, sampleRate: 0 });
    const context = createFormattingContext(options);

    return trace.wrap(async () => {
        const tree = await gastToHast(document, context);
        const pipeline = unified().use(rehypeStringify);
        const root = (await pipeline.run(tree)) as Root;

        return pipeline.stringify(root).toString();
    });
}
